"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useChatsList = void 0;
var react_data_1 = require("@hiyllo/react-data");
var ChatsListBP = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/get-chats-list"));
var MyChatsPSB = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/my-chats.psb"));
var idle_1 = require("@hiyllo/idle");
var react_1 = __importDefault(require("react"));
function useChatsList(sortDirection, _a) {
    var seamlessClient = _a.seamlessClient, cache = _a.cache, self = _a.self, tenant = _a.tenant;
    var idleStateListener = react_1["default"].useRef((0, idle_1.createIdleListener)()).current;
    var chatListDataSource = (0, react_data_1.useMultipleDocuments)(seamlessClient, {
        cache: cache,
        key: 'my-chats',
        subscription: {
            blueprint: MyChatsPSB,
            topic: "[".concat(tenant, "]chat.my-chats/").concat(self.userId)
        },
        query: {
            blueprint: ChatsListBP,
            params: null,
            mapperFn: function (res) { return res.chats; }
        },
        freshnessFn: function (chat) { return chat.lastMessageDate.valueOf(); },
        keyExtractorFn: function (chat) { return chat.uuid; }
    });
    react_1["default"].useEffect(function () {
        var remove = idleStateListener.onActive(function () {
            void chatListDataSource.refreshQuery();
        }).remove;
        return remove;
    }, [chatListDataSource]);
    var chats = chatListDataSource.data.sort(function (a, b) { return sortDirection === 1 ? a.lastMessageDate.valueOf() - b.lastMessageDate.valueOf() : b.lastMessageDate.valueOf() - a.lastMessageDate.valueOf(); }).filter(function (c) { return c.archived !== true; });
    return {
        chats: chats,
        queryLoading: chatListDataSource.queryLoading
    };
}
exports.useChatsList = useChatsList;
